import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Link = styled(NavLink)`
  display: flex;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
